<template>
  <div>
    <vs-alert class="text-center md:w-3/4 mb-4 m-auto" color="warning" v-if="$acl.check('operator')">{{
      $t('messages.end_invoice_tip')
    }}</vs-alert>
    <vs-alert v-if="onCallUser" class="mb-3 text-center">
      <b>توجه: </b>
      سرویس چت تصویری در حالت آزمایشی است. درصورت بروز مشکل صفحه را ریلود کرده و دوباره امتحان کنید، همچنین
      میتوانید از سرویس گوگل میت برای برقراری جلسه استفاده کنید.
      <br />
      <a href="https://meet.google.com/new" target="_blank" class="text-success">ورود به گوگل میت</a><br />
      <a
        target="_blank"
        class="text-warning"
        href="https://virgool.io/@cheyab/%D8%A2%D9%85%D9%88%D8%B2%D8%B4-%DA%A9%D8%A7%D8%B1-%D8%A8%D8%A7-%DA%AF%D9%88%DA%AF%D9%84-%D9%85%DB%8C%D8%AA-%D9%BE%D9%84%D8%AA%D9%81%D8%B1%D9%85%DB%8C-%D8%A8%D8%B1%D8%A7%DB%8C-%D9%87%D9%85%D9%87-bagv0wfkprcq"
      >
        (جهت آموزش بر روی این لینک کلیک کنید)
      </a>
    </vs-alert>
    <video-chat
      :user="onCallUser"
      :is-video-disabled="!isVideoCall"
      :is-caller="isCaller"
      v-if="onCallUser"
      @call-end="callEnd"
      class="mb-2"
    />
    <div id="chat-app" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
      <vs-sidebar
        class="items-no-padding"
        parent="#chat-app"
        :click-not-close="clickNotClose"
        :hidden-background="clickNotClose"
        v-model="isChatSidebarActive"
        id="chat-list-sidebar"
      >
        <!-- USER PROFILE SIDEBAR -->
        <user-profile
          :active="activeProfileSidebar"
          :userId="userProfileId"
          class="user-profile-container"
          :isLoggedInUser="isLoggedInUserProfileView"
          @closeProfileSidebar="closeProfileSidebar"
        ></user-profile>

        <div class="chat__profile-search flex p-4">
          <div class="relative inline-flex p-0">
            <avatar
              class="m-0"
              :id="activeUser.avatar"
              size="45px"
              @click="showProfileSidebar(activeUser.id, true)"
            />
            <div
              class="h-3 w-3 border-white border border-solid rounded-full absolute right-0 bottom-0"
              :class="'bg-' + getStatusColor(true)"
            ></div>
          </div>
          <vs-input
            icon-no-border
            icon="icon-search"
            icon-pack="feather"
            class="w-full mx-5 input-rounded-full"
            :placeholder="$t('chats.search_contacts')"
            v-model="searchQuery"
          />

          <feather-icon
            class="md:inline-flex lg:hidden -ml-3 cursor-pointer"
            icon="XIcon"
            @click="toggleChatSidebar(false)"
          />
        </div>

        <vs-divider class="d-theme-border-grey-light m-0" />
        <component
          v-if="whitelistContacts.length || blacklistContacts.length"
          :is="scrollbarTag"
          class="chat-scroll-area pt-4"
          :key="$vs.rtl"
        >
          <!-- WHITELIST CONTACTS -->
          <div class="chat__chats-list mb-8">
            <h4 class="text-primary mb-5 px-4">{{ $t('chats.open_chats') }}</h4>
            <ul class="chat__active-chats bordered-items">
              <li
                class="cursor-pointer"
                v-for="(contact, index) in whitelistContactsFilter"
                :key="index"
                @click="updateActiveChatUser(contact.userId)"
              >
                <chat-contact
                  :contact="contact"
                  :lastMessaged="chatLastMessaged(contact.userId).time"
                  :unseenMsg="chatUnseenMessages(contact.userId)"
                  :isActiveChatUser="isActiveChatUser(contact.userId)"
                ></chat-contact>
              </li>
            </ul>
          </div>

          <!-- BLACKLIST CONTACTS -->
          <div class="chat__contacts">
            <h4 class="text-primary mb-5 px-4">{{ $t('chats.closed_chats') }}</h4>
            <ul class="chat__contacts bordered-items">
              <li
                class="cursor-pointer"
                v-for="(contact, index) in blacklistContactsFilter"
                :key="index"
                @click="updateActiveChatUser(contact.userId)"
              >
                <chat-contact
                  :contact="contact"
                  :lastMessaged="chatLastMessaged(contact.userId).time"
                  :unseenMsg="chatUnseenMessages(contact.userId)"
                  :isActiveChatUser="isActiveChatUser(contact.userId)"
                ></chat-contact>
              </li>
            </ul>
          </div>
        </component>
        <div v-else>
          <vs-alert class="text-center w-3/4 mt-4 m-auto" color="dark">{{
            $t('chats.no_contacts')
          }}</vs-alert>
        </div>
      </vs-sidebar>

      <!-- RIGHT COLUMN -->
      <div
        class="chat__bg no-scroll-content chat-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0"
        :class="{
          'sidebar-spacer--wide': clickNotClose,
          'flex items-center justify-center': activeChatUser === null
        }"
      >
        <template v-if="activeChatUser">
          <div class="chat__navbar">
            <chat-navbar
              :isSidebarCollapsed="!clickNotClose"
              :user-id="activeChatUser"
              @openContactsSidebar="toggleChatSidebar(true)"
              @showProfileSidebar="showProfileSidebar"
              @videoCallUser="videoCallUser"
              @voiceCallUser="voiceCallUser"
            ></chat-navbar>
          </div>
          <component
            :is="scrollbarTag"
            class="chat-content-scroll-area border border-solid d-theme-border-grey-light"
            ref="chatLogPS"
            :key="$vs.rtl"
          >
            <div class="chat__log" ref="chatLog">
              <chat-log :userId="activeChatUser" v-if="activeChatUser"></chat-log>
            </div>
          </component>
          <div class="chat__input flex p-4 bg-white" v-if="isInWhitelist">
            <vs-button
              class="mr-2"
              icon-pack="feather"
              icon="icon-file"
              type="border"
              color="primary"
              size="large"
              @click="openSendFilePopup"
            ></vs-button>
            <vs-input
              class="flex-1"
              :placeholder="$t('chats.type_your_message')"
              v-model="typedMessage"
              @keyup.enter="sendMsg"
            />
            <vs-button class="bg-primary-gradient ml-3" type="filled" @click="sendMsg">{{
              $t('chats.send')
            }}</vs-button>
          </div>
          <div v-else>
            <vs-alert class="text-center w-3/4 mt-4 m-auto" color="dark">{{
              $t('chats.chat_closed')
            }}</vs-alert>
          </div>
        </template>
        <template v-else>
          <!--          <video-chat />-->
          <div class="flex flex-col items-center">
            <feather-icon
              icon="MessageSquareIcon"
              class="mb-4 bg-white p-8 shadow-md rounded-full"
              svgClasses="w-16 h-16"
            ></feather-icon>
            <h4
              class="py-2 px-4 bg-white shadow-md rounded-full cursor-pointer"
              @click.stop="toggleChatSidebar(true)"
            >
              {{ $t('chats.select_chat') }}
            </h4>
          </div>
        </template>
      </div>
    </div>
    <vs-popup :active.sync="activeSendFilePopup" :title="$t('chats.send_file')">
      <upload-file
        title=""
        v-model="uploaded_files"
        multiple
        ref="uploads"
        :start-upload="startUpload"
        @pending-upload="handlePendingUpload"
      />
      <vs-row class="mt-4" vs-justify="flex-end">
        <vs-button class="mr-2 flex-end" @click="sendFiles" color="success">
          {{ hasPendingFile ? $t('chats.send') : $t('upload_files.upload_file') }}
        </vs-button>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
import ChatContact from './ChatContact.vue'
import ChatLog from './ChatLog.vue'
import ChatNavbar from './ChatNavbar.vue'
import UserProfile from './UserProfile.vue'
import Avatar from '@/views/components/common/Avatar'
import VideoChat from '@/views/pages/chat/VideoChat'
import UploadFile from '@/views/components/forms/UploadFile'

export default {
  name: 'Chat',
  data() {
    return {
      active: true,
      isHidden: false,
      searchContact: '',
      activeProfileSidebar: false,
      userProfileId: -1,
      typedMessage: '',
      clickNotClose: true,
      isChatSidebarActive: true,
      isLoggedInUserProfileView: false,
      searchQuery: '',
      uploaded_files: [],
      activeSendFilePopup: false,
      startUpload: false,
      hasPendingFile: true,
      isVideoCall: true
    }
  },
  watch: {
    windowWidth() {
      this.setSidebarWidth()
    }
  },
  computed: {
    chatLastMessaged() {
      return userId => this.$store.getters['chat/chatLastMessaged'](userId)
    },
    chatUnseenMessages() {
      return userId => {
        const unseenMsg = this.$store.getters['chat/chatUnseenMessages'](userId)
        if (unseenMsg) return unseenMsg
      }
    },
    activeUser() {
      return this.$store.state.AppActiveUser
    },
    getStatusColor() {
      return isActiveUser => {
        const userStatus = this.getUserStatus(isActiveUser)

        if (userStatus === 'online') {
          return 'success'
        } else if (userStatus === 'do not disturb') {
          return 'danger'
        } else if (userStatus === 'away') {
          return 'warning'
        } else {
          return 'grey'
        }
      }
    },
    whitelistContacts() {
      return this.$store.getters['chat/whitelistContacts']
    },
    blacklistContacts() {
      return this.$store.getters['chat/blacklistContacts']
    },
    whitelistContactsFilter() {
      return this.$store.getters['chat/whitelistContacts'].filter(contact =>
        contact.fullName.toLowerCase().includes(this.searchQuery.toLowerCase())
      )
    },
    blacklistContactsFilter() {
      return this.$store.getters['chat/blacklistContacts'].filter(contact =>
        contact.fullName.toLowerCase().includes(this.searchQuery.toLowerCase())
      )
    },
    activeChatUser: {
      get() {
        return this.$store.state.chat.activeChatUser
      },
      set(val) {
        this.$store.dispatch('chat/setActiveChatUser', val)
        this.updateWhitelistStatus()
      }
    },
    onCallUser: {
      get() {
        return this.whitelistContacts.find(u => u.userId === this.$store.state.chat.onCallUser)
      },
      set(val) {
        this.$store.commit('chat/SET_ON_CALL_USER', val)
      }
    },
    isCaller: {
      get() {
        return this.$store.state.chat.isCaller
      },
      set(val) {
        this.$store.commit('chat/SET_IS_CALLER', val)
      }
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
    isActiveChatUser() {
      return userId => userId === this.activeChatUser
    },
    windowWidth() {
      return this.$store.state.windowWidth
    },
    isInWhitelist() {
      return !!this.whitelistContacts.find(u => u.userId === this.activeChatUser)
    }
  },
  methods: {
    getUserStatus(isActiveUser) {
      return isActiveUser ? this.$store.state.AppActiveUser.status : this.contacts[this.activeChatUser].status
    },
    closeProfileSidebar(value) {
      this.activeProfileSidebar = value
    },
    updateActiveChatUser(contactId) {
      this.activeChatUser = contactId
      if (this.$store.getters['chat/chatDataOfUser'](this.activeChatUser)) {
        this.$store.dispatch('chat/markSeenAllMessages', contactId)
      }
      this.toggleChatSidebar()
      this.typedMessage = ''
    },
    showProfileSidebar(userId, openOnLeft = false) {
      this.userProfileId = userId
      this.isLoggedInUserProfileView = openOnLeft
      this.activeProfileSidebar = !this.activeProfileSidebar
    },
    sendMsg() {
      if (!this.typedMessage) return
      const payload = {
        to: this.activeChatUser,
        type: 'text',
        artifacts: [this.typedMessage]
      }
      this.$store.dispatch('chat/sendChatMessage', payload)
      this.typedMessage = ''

      const scroll_el = this.$refs.chatLogPS.$el || this.$refs.chatLogPS
      scroll_el.scrollTop = this.$refs.chatLog.scrollHeight
    },
    openSendFilePopup() {
      this.activeSendFilePopup = true
    },
    handlePendingUpload(value) {
      this.hasPendingFile = !value
    },
    sendFiles() {
      if (!this.hasPendingFile) {
        this.startUpload = true
        return
      }
      if (!this.uploaded_files.length) {
        this.$notifyError('asd')
        return
      }
      const payload = {
        to: this.activeChatUser,
        type: 'file',
        artifacts: this.uploaded_files
      }
      this.$store.dispatch('chat/sendChatMessage', payload)
      this.activeSendFilePopup = false

      const scroll_el = this.$refs.chatLogPS.$el || this.$refs.chatLogPS
      scroll_el.scrollTop = this.$refs.chatLog.scrollHeight
    },
    setSidebarWidth() {
      if (this.windowWidth < 1200) {
        this.isChatSidebarActive = this.clickNotClose = false
      } else {
        this.isChatSidebarActive = this.clickNotClose = true
      }
    },
    toggleChatSidebar(value = false) {
      if (!value && this.clickNotClose) return
      this.isChatSidebarActive = value
    },
    videoCallUser(user) {
      this.isCaller = true
      this.isVideoCall = true
      this.onCallUser = user.userId
    },
    voiceCallUser(user) {
      this.isCaller = true
      this.isVideoCall = false
      this.onCallUser = user.userId
    },
    callEnd() {
      this.onCallUser = null
    },
    updateWhitelistStatus() {
      if (this.whitelistContacts.length)
        this.$store.dispatch(
          'chat/fetchContactsStatus',
          this.whitelistContacts.map(c => c.userId)
        )
    }
  },
  components: {
    UploadFile,
    VideoChat,
    ChatContact,
    UserProfile,
    ChatNavbar,
    ChatLog,
    Avatar
  },
  created() {
    this.$store.dispatch('chat/fetchContacts').then(() =>
      setInterval(() => {
        this.updateWhitelistStatus()
      }, 10000)
    )

    this.$store.dispatch('chat/fetchChats')
    this.setSidebarWidth()
  }
}
</script>

<style lang="scss">
@import '~@/assets/scss/vuexy/apps/chat.scss';
</style>
